import { stringToDate } from '@ui-seeker/utils'

export const parseBackendDate = value => {
	if (!value) return null
	if (value instanceof Date) return value
	const datePart = String(value).split('T')[0]
	if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return stringToDate(datePart, 'yyyy-MM-dd')
	if (/^\d{8}$/.test(datePart)) return stringToDate(datePart, 'yyyyMMdd')
	return null
}
